<template>
  <a-modal width="80%" :centered="true" :visible="visible" :footer="null" @cancel="cancel">
    <div slot="title" class="record-header">
      <div>修改记录</div>
      <a-button @click="downloadXLSX" type="primary">下载记录</a-button>
    </div>
    <div class="record-box">
      <div class="record-left" @scroll="handlerScroll">
        <div v-for="item in updateList" :key="item.id" @click="clickItem(item)" class="left-item" :class="{ 'left-item-active': currentActive === item.id }">
          <div class="left-time">{{ item.createTime }}</div>
          <div class="right-name">{{ item.operator }}</div>
        </div>
        <a-spin :spinning="loading">
          <div class="left-item-loading">{{ emtptText }}</div>
        </a-spin>
      </div>
      <div class="record-right" :class="{ empty: tableRelevant.tableDataSource.length === 0 }">
        <a-table
          v-if="tableRelevant.tableDataSource.length"
          :columns="columns.filter((v) => v.title != '操作')"
          :data-source="tableRelevant.tableDataSource"
          :loading="tableRelevant.tableLoading"
          :pagination="false"
          row-key="关卡标识"
          bordered
          size="middle"
          :scroll="{ y: 450, x: columns.length > 10 ? `calc(${(columns.length - 10) * 100}px + 100%)` : '100%' }"
        >
        </a-table>
        <a-empty v-else description="暂无修改记录" />
      </div>
    </div>
  </a-modal>
</template>
<script>
import { tableRelevant } from '@/pages/projectImpl/js/utils'
import { getHisRecordList, getRecordInfo } from '@/utils/http'
import xlsx from "xlsx-js-style";

// 根据表头类型获取颜色
const getHeaderColor = (type) => {
  const colorMap = {
    1: '#52c41a', // 主参数 - 绿色
    2: '#1890ff', // 副参数 - 蓝色
    3: '#000'     // 其他参数 - 黑色
  }
  return colorMap[type] || '#000'
}
function dbScroll(fn, time = 200) {
  let timeId = null
  return function (...args) {
    if (timeId) {
      clearTimeout(timeId)
    }
    timeId = setTimeout(() => {
      timeId = null
      fn.apply(this, args)
    }, time)
  }
}
export default {
  name: 'UpdateRecordModal',
  props: {
    gameId: [Number, String],
    newNotice: Boolean,
  },
  data() {
    return {
      columns: [],
      visible: false,
      tableRelevant: tableRelevant.call(this),
      updateList: [],
      currentActive: 0,
      loading: false,
      recordPage: {
        pageSize: 10,
        pageIndex: 1,
      },
      emtptText: '',
      pageData: []
    }
  },
  created() {
    // this.getRecordList()
  },
  methods: {
    handlerScroll: dbScroll(function (e) {
      const target = e.target
      if (target.scrollHeight - target.clientHeight <= target.scrollTop && !this.recordEnd && !this.loading) {
        this.recordPage.pageIndex++
        this.getRecordList()
      }
      if (this.recordEnd) {
        this.emtptText = '无更多记录'
      }
    }),
    showModal() {
      return new Promise((res, rej) => {
        this.visible = true
        this._res = res
        this._rej = rej
        this.updateList[0] && (this.updateList[0].isNew = false)
        this.getInfoList()
        this.$emit('newNotice', false)
      })
    },
    async getRecordList(getInfo = false, reset) {
      this.loading = true
      if (reset) {
        this.updateList = []
        this.recordPage.pageIndex = 1
        this.recordEnd = false
      }
      const data = await getHisRecordList({
        contentId: this.$route.query.id,
        PageIndex: this.recordPage.pageIndex,
        PageSize: this.recordPage.pageSize,
      }).finally(() => (this.loading = false))
      if (!data.isSuccess) {
        return this.$message.error(data.message)
      }
      if (data.data.totalPages == this.recordPage.pageIndex) {
        this.recordEnd = true
      }
      this.updateList.push(...data.data.items)
      if (this.updateList.length) {
        this.currentActive = this.updateList[0].id
        if (getInfo) {
          this.getInfoList()
        } else {
          this.$emit(
            'newNotice',
            this.updateList[0].isNew
          )
        }
      }
    },
    async getInfoList() {
      if (!this.updateList.length) {
        return
      }
      this.tableRelevant.tableLoading = true
      const data = await getRecordInfo({ recordId: this.currentActive }).finally(() => (this.tableRelevant.tableLoading = false))
      let recordData = JSON.parse(data.data.data)
      this.pageData = recordData;
      // 如果数据中每个字段是 {HeaderValue, Type, ChineseDesc} 格式,则提取 HeaderValue
      if (recordData.length && typeof recordData[0][Object.keys(recordData[0])[0]] === 'object' && recordData[0][Object.keys(recordData[0])[0]].hasOwnProperty('HeaderValue')) {
        recordData = recordData.map(item => {
          const newItem = {}
          Object.keys(item).forEach(key => {
            newItem[key] = item[key].HeaderValue !== null ? item[key].HeaderValue : ''
          })
          return newItem
        })
      }

      this.tableRelevant.tableDataSource = recordData

      // 处理表头，如果有 headers 字段则使用，否则使用默认格式
      if (data.data.headers && Array.isArray(data.data.headers)) {
        const headers = data.data.headers
        const titleMap = {}
        headers.forEach((h) => {
          titleMap[h.header] = {
            title: `${h.chineseDesc}（${h.header}）`,
            type: h.type
          }
        })

        this.columns = Object.keys(recordData[0]).map((key) => ({
          dataIndex: key,
          title: titleMap[key] ? titleMap[key].title : key,
          align: 'center',
          customHeaderCell: () => ({
            style: {
              color: titleMap[key] ? getHeaderColor(titleMap[key].type) : '#000',
              fontWeight: 'bold'
            }
          })
        }))
      } else {
        // 从原始数据中提取 headers 信息用于表头
        const firstItem = JSON.parse(data.data.data)[0]
        const titleMap = {}
        Object.keys(firstItem).forEach(key => {
          if (firstItem[key] && firstItem[key].ChineseDesc) {
            titleMap[key] = {
              title: `${firstItem[key].ChineseDesc}（${key}）`,
              type: firstItem[key].Type
            }
          }
        })

        this.columns = Object.keys(recordData[0]).map((key, index) => ({
          dataIndex: key,
          title: titleMap[key] ? titleMap[key].title : key,
          align: 'center',
          fixed: index < 3 ? 'left' : undefined,
          width: index < 3 ? 100 : undefined,
          customHeaderCell: () => ({
            style: {
              color: titleMap[key] ? getHeaderColor(titleMap[key].type) : '#000',
              fontWeight: 'bold'
            }
          })
        }))
      }

    },
    cancel() {
      this.visible = false
      this._res()
    },
    clickItem(item) {
      this.currentActive = item.id
      item.isNew = false
      this.getInfoList()
    },
    downloadXLSX() {
      if (!this.pageData.length) {
        this.$message.error("暂无数据");
        return;
      }
      const headers = Object.keys(this.pageData[0]);
      let list = [
        headers.map((m, i) => i === 0 ? "参数类型" : ["", "主参数", "副参数", "其他参数"][this.pageData[0][m]] || "其他参数"),
        headers.map((m, i) => i === 0 ? "中文说明" : this.pageData[0][m].ChineseDesc || ""),
        headers,
      ];
      list = list.concat(this.pageData.map(m => headers.map(h => typeof m[h] !== "object" ? m[h] : m[h].HeaderValue)));


      // 创建一个新的工作簿
      const workbook = xlsx.utils.book_new();
      // 将数据转换为工作表
      const worksheet = xlsx.utils.aoa_to_sheet(list);
      // 添加合并单元格配置
      // 第一行：合并第1、2列（显示"参数类型"）
      // 第二行：合并第1、2列（显示"中文说明"）
      worksheet["!merges"] = [
        { s: { r: 0, c: 0 }, e: { r: 0, c: 1 } }, // 第一行合并第1、2列（参数类型）
        { s: { r: 1, c: 0 }, e: { r: 1, c: 1 } },  // 第二行合并第1、2列（中文说明）
      ];

      // 设置列宽
      const cols = [];
      // 设置内容样式
      Object.keys(worksheet).forEach(f => {
        if (typeof worksheet[f] !== "object") {
          return;
        }
        worksheet[f].s = {
          font: {
            sz: 12,
            color: { rgb: "000000" },
          },
          alignment: {
            horizontal: "center",
            vertical: "center",
          },
        };
      });
      // 设置表头样式
      for (let i = 0; i < 3; i++) {
        headers.forEach((item, index) => {
          const ex = xlsx.utils.encode_cell({ r: i, c: index });
          worksheet[ex].s = {
            font: {
              sz: 12,
              bold: true,
              color: { rgb: worksheet[ex].v === "错误信息" ? "FF0000" : "000000" },
            },
            fill: {
              fgColor: { rgb: "eeeeeeff" }, // 背景
            },
            border: {
              top: { style: "thin", color: { rgb: "000000" } }, // 上边框
              bottom: { style: "thin", color: { rgb: "000000" } }, // 下边框
              left: { style: "thin", color: { rgb: "000000" } }, // 左边框
              right: { style: "thin", color: { rgb: "000000" } }, // 右边框
            },
            alignment: {
              horizontal: "center",
              vertical: "center",
            },
          };
          // 设置列宽
          cols.push({ wpx: 120 });
        });
      }
      // 设置列宽
      worksheet["!cols"] = cols;
      // 设置行高
      worksheet["!rows"] = list.map(m => ({ hpt: 23 }));
      // 将工作表添加到工作簿中
      xlsx.utils.book_append_sheet(workbook, worksheet, "第一页");
      // 将工作簿导出为 Excel 文件
      const updateRecord = this.updateList.find(f => f.id == this.currentActive) || {};
      xlsx.writeFile(workbook, `${updateRecord.operator || ""} ${updateRecord.createTime || ""}关卡数据.xlsx`);
    },
  },
}
</script>
<style lang="less" scoped>
.record-header{
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding-right: 50px;
}
.record-box {
  display: flex;
  gap: 0 12px;
  min-height: 400px;
  height: 540px;
  .record-left {
    overflow-y: auto;
    height: 540px;
    .left-item {
      height: 54px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 200px;
      text-align: center;
      cursor: pointer;
    }
    .left-item-loading {
      height: 54px;
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 200px;
      text-align: center;
      pointer-events: none;
      color: #999;
    }
    .left-item-active {
      background: #c0e5e5;
    }
    .left-item:hover {
      background: #dadada;
    }
    .left-time {
      color: #175ceb;
    }
    .left-name {
      color: #000;
    }
  }
  .record-right {
    flex: 1;
  }
}
.empty {
  display: flex;
  align-items: center;
  justify-content: center;
}
</style>
